module.exports = __webpack_public_path__ + "static/5-happy-man-2c51a6c64fe7d61df258f4b3c3fe5b28.jpg";